import { RightOutlined, SyncOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCalendarCheck } from "@fortawesome/pro-regular-svg-icons"
import { faSnowflake } from "@fortawesome/pro-solid-svg-icons"
import { TaskCalendarEvent } from "../scheduleApi"
import dayjs, { Dayjs } from 'dayjs'

type Props = {
  event: TaskCalendarEvent
  date: Dayjs
  isHovered: boolean
  onMouseEnter: () => void
  onMouseLeave: () => void
  onClick?: () => void
}

const UNASSIGNED_COLOR = '#e0e0e0'

const DayViewTask = ({ event, isHovered, onMouseEnter, onMouseLeave, onClick }: Props) => {
  const color = event.crewForemanColor || UNASSIGNED_COLOR
  const isCompleted = !!event.completedAt

  const formatTimeRange = () => {
    if (event.allDay) {
      return 'All Day'
    }
    const startTime = dayjs(event.start)
    const endTime = dayjs(event.end)
    return `${startTime.format('h:mm A')} - ${endTime.format('h:mm A')}`
  }

  return (
    <div
      style={{
        margin: '4px 16px',
        padding: '10px 12px',
        backgroundColor: 'white',
        borderRadius: '8px',
        borderTop: '1px solid #e8e8e8',
        borderRight: '1px solid #e8e8e8',
        borderBottom: '1px solid #e8e8e8',
        borderLeft: `8px solid ${color}`,
        cursor: onClick ? 'pointer' : 'default',
        boxShadow: isHovered ? `0 0 8px 1px ${color}4D` : 'none',
        transition: 'box-shadow 0.2s, transform 0.2s',
        transform: isHovered ? 'scale(1.02)' : 'scale(1)',
      }}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '15px', fontWeight: '600', color: isCompleted ? '#999' : '#000', textDecoration: isCompleted ? 'line-through' : undefined }}>
          {event.title}
          {event.frozen && (
            <Tooltip title="Frozen">
              <FontAwesomeIcon icon={faSnowflake} style={{ color: '#0958d9', fontSize: 14 }} />
            </Tooltip>
          )}
          {event.repeatingId && (
            <SyncOutlined style={{ color: '#999', fontSize: '14px' }} />
          )}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {onClick && (
            <div
              style={{
                width: '28px',
                height: '28px',
                borderRadius: '8px',
                border: '1px solid #d9d9d9',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <RightOutlined style={{ color: '#999', fontSize: '12px' }} />
            </div>
          )}
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: '13px', color: '#999' }}>
          <FontAwesomeIcon icon={faCalendarCheck} style={{ fontSize: 13 }} />
          <span>TASK</span>
        </div>
        <span style={{ fontSize: '14px', color: '#666' }}>
          {formatTimeRange()}
        </span>
      </div>
    </div>
  )
}

export default DayViewTask
